import React from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';
import {comparisonTitles, comparisonArr, comparisonMobArr} from './data';
import {ComparisonCard} from '../Cards/ComparisonCard';
import {ComparisonMobCard} from '../Cards/ComparisonCard/ComparisonMobCard';
import {Button} from '../Button';

export const Comparisone = ({toggle, active, setActive}) => {
  return (
    <div
      className={clsx(styles.comparisonWrapper, {
        [styles.active]: active,
      })}>
      <div className={styles.deskConparisone}>
        <ComparisonCard list={comparisonTitles} data={comparisonArr} active={toggle} />
      </div>
      <div className={styles.mobConparisone}>
        <ComparisonMobCard data={comparisonMobArr} active={toggle} />
      </div>
      <div className={styles.button}>
        <Button
          onClick={() => setActive((prev) => !prev)}
          text={active ? 'Show Less' : 'Learn More'}></Button>
      </div>
      <div className={styles.decor}></div>
    </div>
  );
};
